// eslint-disable-next-line import/no-extraneous-dependencies
import * as React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={51}
    className={className}
  >
    <text
      data-name="!"
      transform="translate(0 38)"
      fill="#fff"
      fontSize={36}
      fontFamily="Poppins-SemiBold, Poppins"
      fontWeight={600}
    >
      <tspan x={0} y={0}>
        {'i'}
      </tspan>
    </text>
  </svg>
);
